"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M12 2C6.483 2 2 6.485 2 12c0 5.513 4.485 10 10 10 5.513 0 10-4.487 10-10 0-5.515-4.487-10-10-10zm7.998 10c0 1.85-.631 3.553-1.688 4.908L7.098 5.683A7.958 7.958 0 0112 4.002 8.006 8.006 0 0120 12h-.002zM4 12c0-1.845.628-3.545 1.683-4.9L16.89 18.323A7.956 7.956 0 0112 19.998a8.006 8.006 0 01-7.998-8L4 12z" }), "Prohibited");
//# sourceMappingURL=Prohibited.js.map